(function ($, Drupal, drupalSettings, once) {
  'use strict';

  /* eslint-disable */
  Drupal.behaviors.retire_calculator = {
    attach: function () {
      $(once('retire_calculator_currency', 'form.calculator-form input')).on('input', function () {
        var value = $(this).val();
        var input = value.replace(/[^\d.-]/g, '');
        var output = '$' + input.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
        $(this).val(output);
      });

      if( $('#coli-calc-result').is(':empty') ) {
        $('#coli-calc-result').closest('.embedded-content-wrapper').addClass('empty');
      }

      if (!once('onAjaxComplete', 'html').length) {
        return;
      }
      $(document).ajaxComplete(function ( event, xhr, settings ) {
        if (~settings.url.indexOf("/cost-of-living")) {
          $('#coli-calc-result').closest('.embedded-content-wrapper').removeClass('empty');
        }
      });
    }
  };

})(jQuery, Drupal, drupalSettings, once); // eslint-disable-line no-undef
